import { render } from "./tree.vue?vue&type=template&id=4a1a2850&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=4a1a2850&lang=scss&scoped=true"
import "./tree.vue?vue&type=style&index=1&id=4a1a2850&lang=scss"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1a2850"]])

export default __exports__